import { LayoutChangeEvent, View } from 'react-native';
import { ITutorialCard } from './Tutorial.types';
import { style } from './TutorialCard.style';
import { Illustration } from '../illustration/Illustration';
import TextLato from '../text/text-lato/TextLato';
import { PrimaryButton } from '../buttons/primary-button/PrimaryButton';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { PulseDot } from './PulseDot';
import { brand, neutrals } from 'src/theme/colors';
import { useState } from 'react';

export const TutorialCard = ({
  illustration,
  text,
  ctaText,
  onPress,
  x,
  y,
  withDot = false,
  backgroundColor = brand.main.variations['lighterWater-3'],
}: ITutorialCard) => {
  const [size, setSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 });
  const handleLayout = (e: LayoutChangeEvent) => {
    setSize({ width: e.nativeEvent.layout.width, height: e.nativeEvent.layout.height });
  };
  return (
    <>
      {withDot && (
        <View style={{ position: 'absolute', top: y - 20, left: x - 20 }}>
          <PulseDot />
        </View>
      )}
      <View style={[style.card, { top: y, left: x, zIndex: 2 }]} onLayout={handleLayout}>
        <View style={style.topCard}>
          <View style={style.illustration}>
            <Illustration name={illustration} />
          </View>
          <TextLato style={style.text}>{text}</TextLato>
        </View>
        <View style={style.bottomCard}>
          <PrimaryButton
            text={ctaText}
            focusGroup={FocusGroups.MODAL}
            focusId=""
            focusOrder={0}
            textStyle={style.ctaText}
            innerStyle={{ paddingHorizontal: 16, paddingVertical: 5, width: 'auto' }}
            onPress={async () => onPress!()}
            style={{ minHeight: 'auto' }}
          />
        </View>
      </View>
      <View style={[style.card, { ...size, top: y + 5, left: x + 5, zIndex: 1, backgroundColor: neutrals.white }]} />
    </>
  );
};
